export const useTokenElementIdGenerator = () => {
  const generateTokenElementId = (tokenId: number) => {
    return `token-${tokenId}`;
  };

  return { generateTokenElementId };
};
